var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "courseCard" }, [
    _vm.courseList && _vm.courseList.length > 0
      ? _c(
          "div",
          { staticClass: "courseCard" },
          [
            _vm.view === "1"
              ? _vm._l(_vm.courseList, function (i, j) {
                  return _c(
                    "div",
                    {
                      key: j,
                      staticClass: "courseItem",
                      on: {
                        click: function ($event) {
                          return _vm.lookDetails(i.linkUrl)
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "courseImg" }, [
                        _c("img", { attrs: { src: i.img, alt: "暂无图片" } }),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "courseDesc" }, [
                        _c("div", { staticClass: "courseInfoWarp" }, [
                          _c("div", { staticClass: "courseEditor" }, [
                            _c("i", { staticClass: "el-icon-user" }),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(i.teacherName))]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "courseDescTitle" }, [
                          _vm._v(_vm._s(i.name)),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "courseDescSchool" }, [
                          _c("i", { staticClass: "el-icon-school" }),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(i.schoolName))]),
                        ]),
                      ]),
                    ]
                  )
                })
              : _vm._l(_vm.courseList, function (i, j) {
                  return _c(
                    "div",
                    {
                      key: j,
                      staticClass: "courseItem",
                      on: {
                        click: function ($event) {
                          _vm.lookDetails(
                            i.matchContentVoList.filter(function (k) {
                              return k.name === "线上地址"
                            })[0].value
                          )
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "courseImg" }, [
                        i.matchContentVoList
                          ? _c("img", {
                              attrs: {
                                src: i.matchContentVoList.filter(function (k) {
                                  return k.name === "封面"
                                })[0].value,
                                alt: "暂无图片",
                              },
                            })
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "courseDesc" }, [
                        _c("img", {
                          staticClass: "courseUserHd",
                          attrs: {
                            src: i.avatorUrl ? i.avatorUrl : _vm.img202,
                            alt: "",
                          },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "courseEditor" }, [
                          _c("i", { staticClass: "el-icon-user" }),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(i.userName))]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "courseDescTitle" }, [
                          _vm._v(_vm._s(i.courseName)),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "courseDescSchool" }, [
                          _c("i", { staticClass: "el-icon-school" }),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(i.schoolName))]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "courseDescFoot" }, [
                          _c("div", { staticClass: "courseDescTime" }, [
                            _c("i", { staticClass: "el-icon-date" }),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(i.createTime))]),
                          ]),
                        ]),
                      ]),
                    ]
                  )
                }),
          ],
          2
        )
      : _c("div", { staticClass: "noarr" }, [_vm._v("暂无数据")]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }